import React from 'react';
import useStyle from '../table.style';
import { TableInfoLegendary } from 'components/molecules/Table/TableInfoLegendary';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import File from '../../../../assets/background/featureContainer/file.webp';
import { TableInfoContent } from 'components/molecules/Table/TableInfoContent';
import { NoteDef } from 'types/note/note.def';
import { noteDeftoTableMyResultData } from '../../../../helpers/table/noteDeftoTableMyResultData';

export interface TableMyNotesViewProps {
  noteDef: NoteDef;
}

interface contentsDataProps {
  legends: string[];
  me: (string | number)[];
  myClass?: (string | number)[];
}

export const TableMyNotesView = ({ noteDef }: TableMyNotesViewProps) => {
  const classes = useStyle();
  const contentsData: contentsDataProps = noteDeftoTableMyResultData(noteDef);

  return (
    <FeatureContainer backgroundImage={File}>
      <div className={classes.root}>
        <TableInfoLegendary
          legends={contentsData.legends}
          highlightLast={true}
        />
        <div className={classes.contentBlock}>
          <TableInfoContent
            color="Blue"
            contents={contentsData.me}
            isNotes={true}
          />
        </div>
      </div>
    </FeatureContainer>
  );
};
